import generateUtilityClass from '@mui/utils/generateUtilityClass';
import generateUtilityClasses from '@mui/utils/generateUtilityClasses';
import composeClasses from '@mui/utils/composeClasses';
export function getChatSuggestionsUtilityClass(slot) {
  return generateUtilityClass('MuiChatSuggestions', slot);
}
export const chatSuggestionsClasses = generateUtilityClasses('MuiChatSuggestions', ['root', 'item']);
const slots = {
  root: ['root'],
  item: ['item']
};
export const useChatSuggestionsUtilityClasses = classes => composeClasses(slots, getChatSuggestionsUtilityClass, classes);